/**
 * Normalizes boolean values from various sources (Supabase user_metadata, API responses, etc.)
 */
export const normalizeBoolean = (value: unknown): boolean => {
  if (value === true || value === 'true' || value === 1 || value === '1') {
    return true
  }
  return false
}

export const isTruthy = normalizeBoolean

export const isFalsy = (value: unknown): boolean => !normalizeBoolean(value)
